import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Escritorio } from "app/empresas/models/escritorio.model";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";

@Injectable()
export class EscritorioService {
    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Escritório por id
     * @param id ID da escritorio
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "escritorio/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Escritório
     * @param id ID da Escritório
     */
    getAll(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "escritorio" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Escritórios
     * @param id ID
     */
    getAllList(params: any): Observable<ApiPaginationResponseDataNonNullable<Escritorio>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<Escritorio>>(
            this.utilitesService.urlPrefix + "escritorio/lista" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de Escritórios
     * @param id ID
     */
    getTodos(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "escritorio/todos" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Escritório
     * @param id ID da Escritório
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "escritorio/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Escritório
     * @param params Json Escritório
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "escritorio", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Escritório
     * @param params Json Escritório
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "escritorio/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
